<template>
	<div>
		<v-btn class="ml-2"
			:disabled="block" :loading="loading" @click="onClick">Importuj dokumenty</v-btn>

		<input  @change="uploadFile" ref="fileInput" id="fileInput" type="file" v-show="false"
			accept=".xlsx" aria-label="label for document">

		<v-dialog v-model="errorHandler.dialog" width="800">
			<v-card>
				<v-card-title class="headline primary" primary-title>
					Błędy walidacji
				</v-card-title>

				<v-card-text>
					<div v-for="(item, index) in errorHandler.list" :key="index">
						{{index + 1}}. {{item}}
					</div>
				</v-card-text>

				<v-card-actions>
					<v-spacer/>
					<v-btn color="blue" @click="errorHandler.dialog = false">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import {Files} from "@/utils/Files";
import {Api} from "@/api";

export default {
  name: "XlsImportButton",

  watch: {
    "errorHandler.dialog": {
      handler(val) {
        if (!val) {
          this.errorHandler.count = null;
          this.errorHandler.list = [];
        }
      }
    }
  },

  data() {
    return {
      errorHandler: {
        dialog: false,
        count: null,
        list: [],
      },
      loading: false
    };
  },
  props: {
    disabled: {type: Boolean, required: true}
  },
  computed: {
			block() {
				return this.loading || this.disabled;
			}
		},
  methods: {
    onClick(e){
      e.preventDefault();
      this.$refs.fileInput.click();
    },
    async uploadFile() {
      if(this.block)
        return;
      this.loading=true;
      Api.postMultipart(this, "/data-import/financial-tables?projectId=" + this.$route.params.projectId, this.$refs.fileInput.files[0], {},
          successResponse => {
            Files.methods.clearFileInput('fileInput');
            if (successResponse.errors.length > 0) {
              this.errorHandler.count = successResponse.rows.length;
              this.errorHandler.list = successResponse.errors;
              this.errorHandler.dialog = true;
            } else {
              this.$messagesBus.$emit("success", "Dokumenty zostały pomyślnie zaimportowane", successResponse);
              this.$emit("reset");
            }
            this.unblock();
          },
          errorResponse => {
            Files.methods.clearFileInput('fileInput');
            this.$messagesBus.$emit("error", "Nie udało się zaimportować pliku", errorResponse);
            this.unblock();
          });
    },
    unblock(){
      this.$nextTick(() => {
        this.loading=false;
      });
    }
  }
};
</script>

<style scoped>

</style>